<template class="p-1">
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col>
          <b-card>
            <div class="col-lg-4 offset-lg-4" style="text-align:center;">
              <div style="text-align:right">
                <img src="/web/img/mprove_logo.png" class="img-fluid" alt="mProve Logo">
                <h4 style="margin-right: 2rem !important;">Revolutionary Sales Diagnostics.</h4>
                <h4 style="margin-right: 2rem !important;" v-if="IsNotActiveMProve()">DEMO</h4>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card>
            <div class="row">
              <div class="offset-md-2 col-md-4">
                <div class="card bg-primary mb-0" style="text-align:center;">
                  <div class="card-header"><div>Reporting</div></div><div class="card-body">
                    <button type="button" @click="openFinanceReport()" class="btn mr-1 btn-brand btn-dropbox btn-lg"><div style="width: 18px;height: 18px;margin-bottom: -3px;background: url(/web/img/mprove_white_icon.png) left top no-repeat;display: -webkit-inline-box;"></div> <span style="margin:0;">Run Report</span></button>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card bg-success mb-0" style="text-align:center;">
                  <div class="card-header"><div>Settings</div></div><div class="card-body">
                    <button type="button" @click="openSettings()" class="btn mr-1 btn-brand btn-dropbox btn-lg"><i class="fa fa-dropbox"></i><span style="margin:0 0 0 10px;">Open Settings</span></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4" v-if="showImportedData">
              <div class="offset-md-4 col-md-4">
                <div class="card bg-danger mb-0" style="text-align:center;">
                  <div class="card-header"><div>StoneEagle Raw Data</div></div>
                  <div class="card-body">
                    <button type="button" @click="openRawData()" class="btn mr-1 btn-warning btn-lg">
                      <i class="fa fa-database"></i><span style="margin:0 0 0 10px;">View Data</span>
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="IsNotActiveMProve()">
        <b-col>
          <img class="responsive" src="/web/img/graph.png" style="width:100%;" />

        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import store from '@/store'

export default {
  components: {
    loading
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      IsActiveMProve: false,
      showImportedData: false,
      boolLoading: true,
      txtLoading: 'Loading...'
    }
  },
  created () {
    this.getMProveFeature()
    this.showImportedData = store.state.isInternalStaff
  },
  methods: {
    getMProveFeature () {
      var self = this
      self.boolLoading = true
      axios.post('/api/mprove/getFeature', self.request)
        .then(response => {
          self.showDismissibleAlert = false
          if (response.data === undefined || response.data == null) {
            self.errMsg = 'No data was returned'
            self.showDismissibleAlert = true
          } else {
            // self.mProveFeature = response.data.mProve[0];
            this.IsActiveMProve = response.data // self.mProveFeature.IsActive;
          }
          self.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { self.$router.push('/login') }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    IsNotActiveMProve () {
      return this.IsActiveMProve === false
    },
    openFinanceReport () {
      this.$router.push('/mProveReport')
    },
    openSettings () {
      this.$router.push('/mProveSettings')
    },
    openRawData () {
      this.$router.push('/mProveRawData')
    }
  }
}
</script>

<style>
  body {
    background-color: #e4e5e6;
  }
  .breadcrumb {
    display:none !important;
  }
  .btn-dropbox::before {
    content: initial !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/mProve.vue